import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-up fs-3 text-success me-2" }, null, -1)
const _hoisted_3 = { class: "fs-2 fw-bold d-flex" }
const _hoisted_4 = { class: "ms-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-500" }, "Unpaid", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_count_up = _resolveComponent("count-up")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.earnings.totals, (value, currency) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex align-items-center w-100",
        key: currency
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_count_up, {
            "end-val": parseFloat(value)
          }, null, 8, ["end-val"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(currency), 1)
        ])
      ]))
    }), 128)),
    _hoisted_5
  ])), [
    [_directive_loading, _ctx.loading],
    [_vShow, _ctx.earnings.totals.length != 0 || _ctx.loading]
  ])
}